import { useState, useEffect, useRef } from "react";
import "./subscribe-popup.scss";
import axios from "../../axiosConfig.jsx";
import logo from "../../assets/images/logo.png";
import { X } from "lucide-react";
import { useOutsideClick } from "../../lib/use-outside-click";

import gsap from "gsap";
import { useGSAP } from "@gsap/react";

import { toast } from "react-toastify";
import Toast from "../Toast/Toast.jsx";

const SubscribePopup = () => {
  const showInterval = 7;
  const showDelay = 5000;
  const overlayRef = useRef(null);
  const containerRef = useRef(null);
  const [email, setEmail] = useState("");
  const [shouldShow, setShouldShow] = useState(false);
  const tl = useRef(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    console.log(email);
    try {
      const response = await axios.post("/subscribe/new", {
        email: email,
      });

      if (response.status === 201 || response.status === 200) {
        toast(<Toast message="Successfully subscribed!" />, {
          position: "top-left",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setShouldShow(false);
      }
    } catch (error) {
      console.error("Error subscribing to Mailchimp:", error);
      toast(<Toast message="Error subscribing. Please try again." />, {
        position: "top-left",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const getLocalStorage = () => {
    const popupData = localStorage.getItem("subscribe-popup-data");

    if (!popupData) {
      localStorage.setItem(
        "subscribe-popup-data",
        JSON.stringify({
          lastShown: new Date().toISOString(),
          shown: true,
        })
      );
      return true;
    }

    const { lastShown } = JSON.parse(popupData);
    const lastShownDate = new Date(lastShown);
    const now = new Date();
    const daysSinceLastShown =
      (now.getTime() - lastShownDate.getTime()) / (1000 * 60 * 60 * 24);

    return daysSinceLastShown >= showInterval;
  };

  useEffect(() => {
    const shouldShowPopup = getLocalStorage();

    if (shouldShowPopup) {
      const timer = setTimeout(() => {
        setShouldShow(true);
      }, showDelay);

      return () => clearTimeout(timer);
    }
  }, []);

  useOutsideClick(containerRef, () => setShouldShow(false));

  useGSAP(() => {
    if (!overlayRef.current || !containerRef.current) return;

    tl.current = gsap.timeline({ paused: true });

    tl.current
      .set(overlayRef.current, {
        display: "flex",
      })
      .to(overlayRef.current, {
        opacity: 1,
        duration: 0.25,
      })
      .set(containerRef.current, {
        display: "flex",
        y: 25,
      })
      .to(containerRef.current, {
        delay: 0.15,
        opacity: 1,
        duration: 0.25,
        y: 0,
      });
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setShouldShow(false);
    };

    if (shouldShow) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyDown);
      tl.current?.play();
    } else {
      document.body.style.overflow = "auto";
      tl.current?.reverse();

      localStorage.setItem(
        "subscribe-popup-data",
        JSON.stringify({
          lastShown: new Date().toISOString(),
          shown: true,
        })
      );
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [shouldShow]);

  return (
    <div ref={overlayRef} className="subscribe-overlay">
      <button
        className="subscribe-close-button"
        onClick={() => setShouldShow(false)}
      >
        <X />
      </button>
      <div ref={containerRef} className="subscribe-container">
        <div className="subscribe-header">
          <img src={logo} alt="logo" className="subscribe-logo" />
        </div>
        <h2>
          Subscribe to get the latest news and updates about upcoming events.
        </h2>
        <form className="subscribe-form" onSubmit={onSubmit}>
          <input
            type="email"
            placeholder="Enter your email..."
            className="form-element"
            id="email"
            aria-label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            type="submit"
            aria-label="Subscribe"
            className="subscribe-button"
          >
            Subscribe
          </button>
        </form>
      </div>
    </div>
  );
};

export default SubscribePopup;
